import type { PendingReportContext } from '@/types/content-report';

/**
 * ReportContextStore — in-memory hand-off for the "Report AI content" flow.
 *
 * An AI surface (e.g. the home summary card) calls `set()` with the exact
 * artefact the user is reporting, then navigates to the report screen. The
 * screen `peek()`s the context (non-mutating, so it's safe to read in a render
 * initializer even under React StrictMode double-invocation) and `clear()`s it
 * after a successful submit.
 *
 * Opening the report screen generically (from Settings) clears first, so no
 * stale content leaks into an unrelated report.
 */
class ReportContextStore {
  private pending: PendingReportContext | null = null;

  set(context: PendingReportContext): void {
    this.pending = context;
  }

  peek(): PendingReportContext | null {
    return this.pending;
  }

  clear(): void {
    this.pending = null;
  }
}

export const reportContextStore = new ReportContextStore();
